import { UUID } from 'angular2-uuid';

export class SettingConfig {
    action: ActionType;
    data: FieldControl;
    location: any;
    config: any;
    constructor(action, data, location?, config?) {
        this.action = action;
        this.data = data;
        this.location = location;
        this.config = config;
    }
}

export enum ActionType {
    ADD = 'add',
    ADD_LAYOUT = 'addLyaout',
    ADDCONFIG = 'addConfig',
    DELETE = 'delete',
    RESIZE = 'resize',
    SELECT = 'select',
    CHECKREQUIRED = 'checkRequired',
    RESET = 'reset',
    CHANGE_CONFIG = 'change_config',
    CLICK_SECTION = 'click_section',
    MOVE_SECTION = 'MOVE_SECTION'
}

export enum DefaultContextMenu {
    BASICINFOR = 'Basic Information',
    OTHER = 'Other'
}

export class FieldControl {
    name: string;
    type: FieldType;
    isDisable: boolean;
    isRemove: boolean;
    id: string;

    constructor(name, type, isDisable = false, isRemove = true, id?) {
        this.name = name;
        this.type = type;
        this.isDisable = isDisable;
        this.isRemove = isRemove;
        this.id = UUID.UUID();
    }
}

// contact setting field
export const contactDefField = {
    Birthday: 'Birthday',
    Gender: 'Gender',
    MiddleName: 'Middle Name',
    Prefix: 'Prefix',
    Suffix: 'Suffix'
};

export enum FieldType {
    INPUT = 'input',
    DATE = 'date',
    singleDropdown = 'singleDropdown',
    TEXT = 'text',
    combineDropdownInput = 'combine-dropdown-input',
    address = 'combine-address',
}

export const rowFieldJson = {
    'config': {
        'controlName': 'newControl',
        'controlType': 'input',
        'controlID': '9189ed29-5e53-432d-a82c-b04ca4538095',
        'type': 'newControl',
        'isLabelHidden': false,
        'isHidden': false,
        'isRequired': false,
        'isDisabled': false,
        'isRemoved': true
    },
    'css': {
        'labelSize': '14',
        'width': '616',
        'height': '32'
    },
    'dataSource': [
        {}
    ]
};


